import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-hidden-on-mobile',
  templateUrl: './layout-hidden-on-mobile.component.html',
  styleUrls: [ './layout-hidden-on-mobile.component.scss' ],
  standalone: true
})
export class LayoutHiddenOnMobileComponent {
  show = false;

  toggle() {
    this.show = !this.show;
  }
}
